import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import { addToCart, removeFromCart } from '../actions/cartActions'

const CartScreeen = ({ match, location, history }) => {
  const productId = match.params.id

  const qty = location.search ? Number(location.search.split('=')[1]) : 1

  const dispatch = useDispatch()

  const cart = useSelector((state) => state.cart)
  const { cartItems } = cart

  useEffect(() => {
    if (productId) {
      dispatch(addToCart(productId, qty))
    }
  }, [dispatch, productId, qty])

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id))
  }

  const checkOutHandler = () => {
    history.push('/login?redirect=shipping')
  }

  return (
    <div className='row'>
      <div className='col-md-8'>
        <h1>Shopping Cart</h1>
        {cartItems.length === 0 ? (
          <Message variant='info'>
            Your cart is empty <Link to='/'>Go Back</Link>
          </Message>
        ) : (
          <ul className='list-group list-group-flush'>
            {cartItems.map((item) => (
              <li className='list-group-item' key={item.product}>
                <div className='row'>
                  <div className='col-md-2'>
                    <img
                      src={item.image}
                      alt={item.name}
                      className='img-fluid img-rounded'
                    />
                  </div>
                  <div className='col-md-3'>
                    <Link
                      to={`/product/${item.product}`}
                      className='text-dark'
                      style={{ textDecoration: 'none' }}
                    >
                      {item.name}
                    </Link>
                  </div>
                  <div className='col-md-2'>${item.price}</div>
                  <div className='col-md-2'>
                    <div className='col'>
                      <select
                        className='form-control'
                        value={item.qty}
                        onChange={(e) =>
                          dispatch(
                            addToCart(item.product, Number(e.target.value))
                          )
                        }
                      >
                        {[...Array(item.countInStock).keys()].map((x) => (
                          <option key={x + 1} value={x + 1}>
                            {x + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className='col-md-2'>
                    <button
                      type='button'
                      className='btn btn-light'
                      onClick={() => removeFromCartHandler(item.product)}
                    >
                      <i className='fas fa-trash'></i>
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className='col-md-4'>
        <div className='card'>
          <ul className='list-group list-group-flush p-2'>
            <li className='list-group-item'>
              <h2>
                Subtotal ({cartItems.reduce((acc, item) => acc + item.qty, 0)})
                items
              </h2>
              $
              {cartItems
                .reduce((acc, item) => acc + item.qty * item.price, 0)
                .toFixed(2)}
            </li>
            <li className='list-group-item'>
              <button
                type='button'
                className='btn btn-dark btn-block'
                disabled={cartItems.length === 0}
                onClick={checkOutHandler}
              >
                Proceed To Checkout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default CartScreeen
